import React from 'react'
// import { FaFacebookF, FaLinkedinIn, FaReact, FaGithub, FaInstagram } from "react-icons/fa";
// import { SiTailwindcss, SiFigma, SiNextdotjs, SiUpwork } from "react-icons/si";
import { FaFacebookF, FaLinkedinIn, FaGithub, FaInstagram } from "react-icons/fa";
import { SiUpwork } from "react-icons/si";

const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          {/* <h2 className="text-base uppercase font-titleFont mb-4">
            Find me in
          </h2> */}
          <div className="flex gap-2">
            <a href='https://www.linkedin.com/in/fourat-abdellatif' target='_blank' rel="noreferrer" className="bannerIcon">
              <FaLinkedinIn />
            </a>
            <a href='https://www.facebook.com/fourat.abdellatif.3' target='_blank' rel="noreferrer" className="bannerIcon">
              <FaFacebookF />
            </a>
            <a href='https://www.instagram.com/fourat.abdeltif' target='_blank' rel="noreferrer" className="bannerIcon">
              <FaInstagram />
            </a>
            <a href='https://github.com/fouratabdellatif' target='_blank' rel="noreferrer" className="bannerIcon">
              <FaGithub />
            </a>
            <a href='https://www.upwork.com/freelancers/~01a64f5a81d6d1dc57' target='_blank' rel="noreferrer" className="bannerIcon">
              <SiUpwork />
            </a>
          </div>
        </div>
        {/* <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <FaReact />
            </span>
            <span className="bannerIcon">
              <SiNextdotjs />
            </span>
            <span className="bannerIcon">
              <SiTailwindcss />
            </span>
            <span className="bannerIcon">
              <SiFigma />
            </span>
          </div>
        </div> */}
      </div>
  )
}

export default Media